export function LiveGameTime({ time }) {
	const totalSeconds = Math.floor(time)
	const minutes = Math.floor(totalSeconds / 60)
	const seconds = totalSeconds % 60
	return (
		<>
			<div className="flex-1 flex justify-end">
				{String(minutes).padStart(2, '0')}
			</div>
			<div className="mx-0" alt="">
				:
			</div>
			<div className="flex-1 flex justify-start">
				{String(seconds).padStart(2, '0')}
			</div>
		</>
	)
}
